// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".purchaser-search-card .search-card-front{transition:background-color 0.2s ease-in-out, color 0.2s ease-in-out}.purchaser-search-card .search-card-front .card-title{transition:color 0.2s ease-in-out}.purchaser-search-card .search-card-front:hover{color:#fff;background-color:#104182}.purchaser-search-card .search-card-front:hover .card-title{color:#fff}.purchaser-search-card .search-card-front:hover .card-footer{background-color:#0a2a55}\n", ""]);
// Exports
module.exports = exports;
